module.exports = __webpack_public_path__ + "img/buddy.9eb92ff4.png";